let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4tT2p")).then(() => parcelRequire('3HyEO'));